var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import "./styles.css";
export var Button = forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, _b = _a.size, size = _b === void 0 ? 'small' : _b, _c = _a.variant, variant = _c === void 0 ? 'outlined' : _c, disabled = _a.disabled, startIcon = _a.startIcon, endIcon = _a.endIcon, props = __rest(_a, ["className", "children", "size", "variant", "disabled", "startIcon", "endIcon"]);
    var buttonClassNames = classNames('lk-ui_button', "lk-ui_button__" + size, "lk-ui_button__" + variant, !!startIcon && 'lk-ui_button__start-icon', !!endIcon && 'lk-ui_button__end-icon', !children && 'lk-ui_button__icon-button', disabled && 'lk-ui_button__disabled', className);
    return (React.createElement("button", __assign({}, props, { className: buttonClassNames, disabled: disabled, ref: ref }),
        startIcon && (React.createElement("div", { className: 'lk-ui_button-start-icon' }, startIcon)),
        children,
        endIcon && React.createElement("div", { className: 'lk-ui_button-end-icon' }, endIcon)));
});
